import { render } from "./contact-button.vue?vue&type=template&id=24d0620f&scoped=true"
import script from "./contact-button.vue?vue&type=script&lang=js"
export * from "./contact-button.vue?vue&type=script&lang=js"

import "./contact-button.vue?vue&type=style&index=0&id=24d0620f&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24d0620f"]])

export default __exports__